import {
  getDictionaryList,
  getAppTypeList
} from '@/api/Sys'

const stateMap = {
  // 性别
  'XB': 'xbDicts',
  // 电梯类型
  'DTLX': 'dtlxDicts',
  // 电梯运行状态
  'YXZT': 'yxztDicts',
  // 电梯停保状态
  'TBZT': 'tbztDicts',
  // 电子工单
  'DZGD': 'dzgdDicts',
  // 重点场所
  'ZDCS': 'zdcsDicts',
  // 保养方式
  'BYFS': 'byfsDicts',
  // 电梯保险
  'DTBX': 'dtbxDicts',
  // 保养类型
  'BYLX': 'bylxDicts',
  // 合同来源
  'HTLY': 'htlyDicts',
  // 合同类型
  'HTLX': 'htlxDicts',
  // 年检费用
  'NJFY': 'njfyDicts',
  // 服务方式
  'FWFS': 'fwfsDicts',
  // 支付方式
  'ZFFS': 'zffsDicts',
  // 是否驻场
  'SFZC': 'sfzcDicts',
  // 是否有维修费
  'SFWXF': 'sfwxfDicts',
  // 有无机房
  'YWJF': 'ywjfDicts',
  // 维修费来源
  'WXFLY': 'wxflyDicts',
  // 维修费-费用类型
  'WXF_FYLX': 'wxffylxDicts',
  //维修单状态
  'WXDZT': 'WXDZTDicts',
  // 维修费-收费状态
  'WXF_SFZT': 'wxfsfztDicts',
  'WXMBXX': 'WXMBXXDicts',
  'JSWDLX': 'JSWDLXDicts',
  'WBQZWC':"WBQZWCDicts",
  'WBDSHZT': 'processStatusDicts'
}

export default {
  namespaced: true,
  state: {
    name: 'common',
    xbDicts: [],
    yylxDicts: [],
    dtlxDicts: [],
    yxztDicts: [],
    tbztDicts: [],
    dzgdDicts: [],
    zdcsDicts: [],
    byfsDicts: [],
    dtbxDicts: [],
    bylxDicts: [],
    htlyDicts: [],
    htlxDicts: [],
    njfyDicts: [],
    fwfsDicts: [],
    zffsDicts: [],
    sfzcDicts: [],
    sfwxfDicts: [],
    ywjfDicts: [],
    wxflyDicts: [],
    wxffylxDicts: [],
    WXDZTDicts: [],
    wxfsfztDicts: [],
    WXMBXXDicts: [],
    JSWDLXDicts: [],
    WBQZWCDicts: [],
    processStatusDicts: []
  },
  actions: {
    async setDict({
      commit
    }, dictionaryClass) {
      const res = await getDictionaryList({
        dictionaryClass
      })
      if (res.code === 200) {
        const dictionaryArray = res.data.map((item) => {
          return {
            dictionaryCode: item.dictionaryCode,
            dictionaryValue: item.dictionaryValue,
            dictionaryClass: item.dictionaryClass
          }
        })
        commit('setDictionary', {
          dictionaryArray,
          dictionaryClass
        })
      }
    },
    setDctByArr({
      dispatch
    }) {
      dispatch('setAppList')
      for (let key in stateMap) {
        dispatch('setDict', key)
      }
    },
    async setAppList({
      commit
    }) {
      const res = await getAppTypeList();
      if (res.code === 200) {
        commit('setAppList', res.data)
      }
    }
  },
  mutations: {
    setDictionary(state, obj) {
      state[stateMap[obj.dictionaryClass]] = obj.dictionaryArray
    },
    setAppList(state, arr) {
      state['yylxDicts'] = arr
    }
  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/modules/dictionary.js